import { memo, useMemo } from 'react';
import CaptionPresetPreviewCard from './CaptionPresetPreviewCard';
import { getAvailablePresetNames } from '@/player-config/src/caption-presets/utils';
import { CaptionPresetName } from '@/player-config/src/caption-presets/types';

interface ClipCustomizerCaptionsGalleryPopupProps {
  onPresetSelect: (presetName: CaptionPresetName) => void;
  selectedPreset?: string;
}

function ClipCustomizerCaptionsGalleryPopup({
  onPresetSelect,
  selectedPreset
}: ClipCustomizerCaptionsGalleryPopupProps) {
  const presets = useMemo(() => {
    return getAvailablePresetNames().filter(name => name !== 'custom');
  }, []);

  return (
    <div className="flex flex-col">
      <div className="border-b border-gray-200 px-4 pb-3">
        <p className="text-sm text-gray-600">
          Choose a caption style for your video. Hover over previews to see animations.
        </p>
      </div>

      <div className="p-4">
        <div className="grid grid-cols-1 gap-3">
          {presets.map(presetName => (
            <CaptionPresetPreviewCard
              key={presetName}
              presetName={presetName}
              isSelected={selectedPreset === presetName}
              onClick={() => onPresetSelect(presetName)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(ClipCustomizerCaptionsGalleryPopup);
